import { Licenses } from "../Data/Licenses.ts"
import useCheckLicense from "../Hooks/useCheckLicense.ts"
import ScrollUpArrow from "./Components/ScrollUpArrow"
import Footer from "./Footer"

import './Styles/AboutCompanyStyles.css'

const AboutCompanyIndex = () => {
    const { checkLicense } = useCheckLicense()

    const handleSelectContent = () => {
        let isCarmenLicense = checkLicense([Licenses.Carmen, Licenses.Ferrodo])
        if (isCarmenLicense) {
            return <CarmenAbout />
        }
        else {
            return null
        }
    }

    return (<>
        <ScrollUpArrow />
        <div className="container main-container-holder">
            {handleSelectContent()}
        </div>
        <Footer />
    </>
    )
}

const CarmenAbout = () => {
    return (<>
        <div className="row">
            <div className="col-auto d-flex flex-column">
                <img className="about-img" src="/data/fs01340Files/fs01340-1.jpg" />
                <img className="about-img" src="/data/fs01340Files/fs01340-2.jpg" />
                <img className="about-img" src="/data/fs01340Files/fs01340-3.jpg" />
                <img className="about-img" src="/data/fs01340Files/fs01340-4.jpg" />
            </div>
            <div className="d-flex flex-column col">
                <span>Witamy!</span>
                <span className="mt-3">Firma CARMEN powstała w 1990 roku, w czasach kiedy w Polsce rozpoczęły się przemiany ustrojowe.
                    Pozwoliły one na ukształtowanie się wolnego rynku a tym samym na rozwój prywatnej przedsiębiorczości. Carmen jest polskim przedsiębiorstwem,
                    finansowanym w 100 % kapitałem krajowym.
                </span>
                <span className="mt-3">Od początku firma Carmen zajmowała się handlem hurtowym wyrobów FMCG. Od pierwszego dnia działalności rozwija się bardzo dynamicznie,
                    stając się jednym z liderów na polskim rynku w dziedzinie produktów szybkozbywalnych.
                    Jest bezpośrednim dystrybutorem wszystkich koncernów tytoniowych i operatorów komórkowych.
                </span>
                <span className="mt-3">W październiku 2001 roku przedsiębiorstwo zmieniło formę prawną ze spółki cywilnej na spółkę jawną,
                    zaś w roku 2005 zostało przekształcone w spółkę z ograniczoną odpowiedzialnością zmieniając też nazwę na Carmen Polska Sp. z o.o.
                </span>
                <span className="mt-3">Centrala firmy mieści się w Sochaczewie przy ulicy Warszawskiej 93. Dogodną i sprawną obsługę zapewniamy wykorzystując sieć 19-stu oddziałów rozlokowanych na całym Mazowszu.</span>
                <span className="mt-3">Carmen Polska dysponuje nowoczesnymi centrami dystrybucyjnymi oraz oferuje dogodne formy handlu co zapewnia sprawną i szybką obsługę naszych klientów.
                    Przedstawiciele handlowi to profesjonalny, młody i otwarty na nowe wyzwania zespół, który umożliwia zaspokojenie wszelkich potrzeb naszych partnerów handlowych.
                    Obsługa zawsze pomoże przy tworzeniu zamówień, doborze optymalnego asortymentu i zarządzaniu stanami magazynowymi chcąc zapewnić naszym odbiorcom pełny
                    komfort i zadowolenie ze współpracy. Przedsiębiorstwo oferuje szybki, pewny i bezpłatny dowóz do punktu handlowego w ciągu 24 godzin.
                </span>
            </div>
        </div>
        <div className="row mt-3">
            <div className="col d-flex flex-column">
                <span>Atrakcyjne ceny, ciekawe promocje oraz nowości rynkowe to stały punkt w ofercie handlowej, która zawiera pełny asortyment:</span>
                <ul className="mt-1">
                    <li>papierosów</li>
                    <li>tytoni i akcesoriów</li>
                    <li>kart telefonicznych, staterów i terminali</li>
                    <li>baterii</li>
                    <li>prezerwatyw</li>
                    <li>zapałek i zapalniczek</li>
                    <li>gum do żucia</li>
                    <li>biletów komunikacji miejskiej</li>
                    <li>napojów energetycznych</li>
                    <li>artykułów spożywczych</li>
                    <li>oraz innych produktów szybkozbywalnych.</li>
                </ul>
                <span className="mt-3">W celu ułatwienia i dopasowania do indywidualnych potrzeb, klient może wybierać różne formy zakupu w systemie: Cash&Carry,
                    telemarketingu, preselingu oraz za pośrednictwem hurtowni internetowej.
                </span>
                <span className="mt-3">Zapraszamy do współpracy wszystkich klientów, którzy cenią solidność, stabilność, wysoką jakość usług oraz pewny i stały zysk.
                    Klientom zapewniamy satysfakcję i zadowolenie z naszych usług.
                </span>
                <span className="mt-3">Zapraszamy na kolejne strony naszego serwisu w celu zapoznania się z ofertą oraz adresami naszych oddziałów.</span>
                <b className="mt-3">Inwestycja w polecany przez nas towar to pewny zysk.</b>
            </div>
        </div>
    </>)
}

export default AboutCompanyIndex